import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';

import { useApplicationUserQuery, useChangeStatusMutation } from 'entities/application/api';
import { MpButton } from 'shared/ui/MpButton';
import { WarningIconStyled } from './DeleteApplication.styles';

type DeleteApplicationProps = {
	applicationId: string;
	handleButtonClick: () => void;
	redirectUrl: string;
};

export const DeleteApplication: React.FC<DeleteApplicationProps> = ({
	applicationId,
	handleButtonClick,
	redirectUrl,
}) => {
	const { refetch: refetchApplication } = useApplicationUserQuery(applicationId);
	const [changeStatus, { isSuccess: isChangeStatusSuccess }] = useChangeStatusMutation();

	const { t } = useTranslation();

	useEffect(() => {
		if (isChangeStatusSuccess) {
			void refetchApplication();
		}
	}, [isChangeStatusSuccess, refetchApplication]);

	const redirectToApplication = (): void => {
		window.location.href = redirectUrl;
	};

	const handleDeleteConfirm = async (): Promise<void> => {
		await changeStatus({
			id: applicationId,
			status: `Deleted`,
		});
		handleButtonClick();
		if (redirectUrl !== ``) {
			redirectToApplication();
		}
	};

	const handleDelete = (): void => {
		Modal.warning({
			title: t(`Marketplace_Delete_Modal_Title`),
			content: t(`Marketplace_Delete_Modal_Text`),
			autoFocusButton: `cancel`,
			okText: t(`Marketplace_Delete`),
			cancelText: t(`Marketplace_Delete_Modal_Cancel`),
			icon: <WarningIconStyled />,
			okCancel: true,
			onOk: handleDeleteConfirm,
			okButtonProps: {
				danger: true,
				type: `primary`,
			},
		});
	};

	return (
		// eslint-disable-next-line react/jsx-no-bind
		<MpButton size='large' type='default' danger fullWidth onClick={handleDelete}>
			{t(`Marketplace_Delete`)}
		</MpButton>
	);
};
